<template>
    <div :class="{'is-active': isOpened}">
        <div @click="onClick" class="v-accordion-item__top">
            <slot name="title" :is-expanded="isOpened">
                <!---->
            </slot>
        </div>
        <div class="v-accordion-item__content" :style="{'height': isOpened ? 'auto' : '0', 'overflow': 'hidden'}">
            <slot name="content" :is-expanded="isOpened">
                <!---->
            </slot>
        </div>
    </div>
</template>
<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { dataLayer } from '../globals';
import { EventBus } from '../helpers/bus';
import { Expandable } from './AccordionTypes';
import BaseComponent from './Base';

@Component
    export default class AccordionItem extends BaseComponent implements Expandable {
        protected isOpened: boolean = false;
        @Prop({ type: [Number, Boolean], default: undefined }) protected readonly index: number | undefined;

        public isExpanded(): boolean {
            return this.isOpened;
        }

        public expand(state?: boolean): void {
            this.isOpened = state || !this.isOpened;
            this.$nextTick(() => {
                if (this.isOpened) {
                    EventBus.$emit('updateSwipers');
                }
            });
        }

        public getIndex(): number | undefined {
          return this.index;
        }

        protected onClick(): void {
            const pvm: any = this.$parent;
            const titleEl: any = this.$el.childNodes[0];
            if (this.isOpened) {
                dataLayer.push({
                    eventAction: 'Folded',
                    eventLabel: 'Folded ' + titleEl.innerText,
                    eventCategory: pvm.gtmCategory,
                    event: 'accordion:folded',
                });
            } else {
                dataLayer.push({
                    eventAction: 'Expanded',
                    eventLabel: 'Expanded ' + titleEl.innerText,
                    eventCategory: pvm.gtmCategory,
                    event: 'accordion:expanded',
                });
            }
            this.expand();
        }

        protected beforeMount(): void {
            // TODO: find a better way to do class merge
            if (this.$vnode.data) {
                // this.$vnode.data.staticClass = '';
            }
        }
    }
</script>
<style lang="scss">
@media print {
    h2 {
        display: inline-block !important;
        padding: 0;
        margin-top: 0;
        margin-bottom: 0;
        color: #464646;
        font-size: 20px;
    }
}
</style>
